module.exports = __webpack_public_path__ + "img/fist.2b4b00b0.svg";